import {
  Box, Typography, FormControlLabel, Container, styled,
} from '@material-ui/core';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const FlexContainer = styled(Container)({
  flex: 1,
});

export const HeaderBox = styled(Box)({
  marginTop: 32,
  marginBottom: 40,
});

export const Title = styled(Typography)({
  marginBottom: 8,
});

export const ConsentLabel = styled(FormControlLabel)({
  marginTop: 24,
  marginBottom: 32,
  alignItems: 'flex-start',
});
